<template>
  <header class="header" :class="{ 'menu-open': isMobileMenuOpen, 'sub-page': isSubPage }">
    <div class="header-inner">
      <!-- 중앙 로고 -->
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/logo/logo2.png" alt="로고" />
        </router-link>
      </div>

      <div class="header-right">
        <!-- PC: 전화번호 박스 -->
        <div class="phone-box">
          <span class="phone-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
          </span>
          <a href="tel:1800-1088">1800-1088</a>
        </div>

        <!-- 햄버거 메뉴 -->
        <button class="hamburger-btn" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <div class="fullscreen-menu" :class="{ open: isMobileMenuOpen }">
      <!-- 배경 오버레이 -->
      <div class="menu-backdrop" @click="closeMobileMenu"></div>

      <!-- 왼쪽: 이미지 섹션 -->
      <div class="menu-image-section">
        <img src="@/assets/1.png" alt="background" class="menu-bg-image" />
        <div class="menu-logo-wrapper">
          <img src="@/assets/logo/logo2.png" alt="로고" class="menu-logo" />
        </div>
      </div>

      <!-- 오른쪽: 메뉴 섹션 -->
      <div class="menu-content-section">
        <div class="menu-content-inner">
          <ul class="menu-list">
            <li v-for="menu in menuList" :key="menu.title" class="menu-item">
              <button class="menu-title" @click="toggleSubMenu(menu.title)" :class="{ active: openSubMenu === menu.title }">
                {{ menu.title }}
                <span class="arrow"></span>
              </button>
              <ul class="sub-menu" :class="{ open: openSubMenu === menu.title }">
                <li v-for="sub in menu.subMenu" :key="sub.name">
                  <router-link :to="sub.path" @click="closeMobileMenu">{{ sub.name }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
          <div class="menu-phone">
            <a href="tel:1800-1088">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              1800-1088
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      isMobileMenuOpen: false,
      openSubMenu: null,
      menuList: [
        {
          title: '사업개요',
          path: '/business',
          subMenu: [
            { name: '사업개요', path: '/business/overview' },
            { name: '입지환경', path: '/business/location-env' },
            { name: '프리미엄', path: '/business/premium' },
            { name: '브랜드소개', path: '/business/brand' },
            { name: '오시는길', path: '/business/location' },
          ]
        },
        {
          title: '단지안내',
          path: '/complex',
          subMenu: [
            { name: '단지/동·호배치도', path: '/complex/layout' },
            { name: '커뮤니티', path: '/complex/community' },
          ]
        },
        {
          title: '세대안내',
          path: '/unit',
          subMenu: [
            { name: '유니트안내', path: '/unit/type' },
          ]
        },
        {
          title: '고객센터',
          path: '/support',
          subMenu: [
            { name: '관심고객등록', path: '/support' }
          ]
        }
      ]
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      if (!this.isMobileMenuOpen) {
        this.openSubMenu = null
      }
    },
    toggleSubMenu(title) {
      this.openSubMenu = this.openSubMenu === title ? null : title
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      this.openSubMenu = null
    }
  },
  computed: {
    isSubPage() {
      return this.$route.path !== '/'
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: transparent;
  z-index: 1000;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 20px 0;
}

.header.menu-open {
  background: transparent;
  padding: 20px 0;
}

/* 서브페이지 헤더 스타일 */
.header.sub-page {
  background: #1a1a2e;
}

.header.sub-page .hamburger-btn span {
  background: #fff;
}

.header-inner {
  width: 100%;
  padding: 0 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  flex-shrink: 0;
  z-index: 1001;
}

.logo img {
  height: 24px;
  transition: all 0.3s;
}

.logo:hover img {
  opacity: 0.85;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 1001;
}

/* Phone Box - 골드 원형 */
.phone-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  background: var(--main-color1);
  border: none;
  border-radius: 50px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.phone-box:hover {
  background: var(--main-color2);
  transform: translateY(-2px);
}

.phone-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.phone-icon svg {
  width: 22px;
  height: 22px;
  display: block;
}

.phone-box a {
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  text-decoration: none;
  letter-spacing: 0.5px;
  line-height: 1;
  display: flex;
  align-items: center;
  transition: all 0.3s;
}

/* Hamburger Button - 심플 */
.hamburger-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  gap: 6px;
  padding: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.hamburger-btn:hover span {
  background: var(--main-color1);
}

.hamburger-btn span {
  display: block;
  width: 26px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
}

.hamburger-btn.active span {
  background: #fff;
}

.hamburger-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger-btn.active span:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}

.hamburger-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* Fullscreen Menu - 양쪽에서 슬라이드 */
.fullscreen-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: transparent;
  visibility: hidden;
  pointer-events: none;
  display: flex;
  z-index: 999;
  transition: visibility 0s linear 0.9s; /* 닫을 때: 애니메이션 끝난 후 숨김 */
}

.fullscreen-menu.open {
  visibility: visible;
  pointer-events: auto;
  transition: visibility 0s linear 0s; /* 열 때: 바로 보임 */
}

/* 배경 오버레이 - 부드러운 fade */
.menu-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.6s ease 0.3s; /* 닫을 때: 패널 닫힌 후 fade out */
  z-index: 0;
}

.fullscreen-menu.open .menu-backdrop {
  opacity: 1;
  transition: opacity 0.5s ease; /* 열 때: 바로 fade in */
}

/* 왼쪽 이미지 섹션 - 왼쪽에서 슬라이드 인 */
.menu-image-section {
  width: 50%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #0a0a0a;
  transform: translateX(-100%);
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0.1s;
  z-index: 1;
}

.fullscreen-menu.open .menu-image-section {
  transform: translateX(0);
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 배경 이미지 */
.menu-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transform: scale(1.05);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 0.2s;
}

.fullscreen-menu.open .menu-bg-image {
  opacity: 1;
  transform: scale(1);
}

/* 로고 래퍼 - 배경 위에 중앙 배치 */
.menu-logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  opacity: 0;
  transition: opacity 0.6s ease 0.4s;
}

.fullscreen-menu.open .menu-logo-wrapper {
  opacity: 1;
}

.menu-logo {
  height: 40px;
  width: auto;
}

/* 오른쪽 메뉴 섹션 - 오른쪽에서 슬라이드 인 */
.menu-content-section {
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 60px;
  overflow-y: auto;
  background: #0a0a0a;
  transform: translateX(100%);
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0.1s; /* 닫을 때 */
  z-index: 1;
}

.fullscreen-menu.open .menu-content-section {
  transform: translateX(0);
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1); /* 열 때 */
}

.menu-content-inner {
  width: 100%;
  max-width: 400px;
}

.menu-list {
  list-style: none;
  margin-bottom: 50px;
}

.menu-item {
  margin-bottom: 5px;
  opacity: 0;
  transform: translateX(30px);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.fullscreen-menu.open .menu-item {
  opacity: 1;
  transform: translateX(0);
}

.fullscreen-menu.open .menu-item:nth-child(1) { transition-delay: 0.4s; }
.fullscreen-menu.open .menu-item:nth-child(2) { transition-delay: 0.5s; }
.fullscreen-menu.open .menu-item:nth-child(3) { transition-delay: 0.6s; }
.fullscreen-menu.open .menu-item:nth-child(4) { transition-delay: 0.7s; }

.menu-title {
  font-size: 24px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 18px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 1px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.menu-title:hover {
  color: #fff;
  padding-left: 10px;
}

.menu-title .arrow {
  width: 10px;
  height: 10px;
  border-right: 1.5px solid rgba(255, 255, 255, 0.4);
  border-bottom: 1.5px solid rgba(255, 255, 255, 0.4);
  transform: rotate(45deg);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-title:hover .arrow {
  border-color: var(--main-color1);
  transform: rotate(45deg) translate(3px, 3px);
}

.menu-title.active {
  color: var(--main-color1);
}

.menu-title.active .arrow {
  transform: rotate(-135deg);
  border-color: var(--main-color1);
}

.sub-menu {
  list-style: none;
  max-height: 0;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(255, 255, 255, 0.03);
  margin: 0 -20px;
  padding: 0 20px;
}

.sub-menu.open {
  max-height: 350px;
  padding: 15px 20px;
}

.sub-menu li a {
  display: block;
  padding: 12px 15px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: all 0.3s;
  letter-spacing: 0.5px;
  font-weight: 300;
}

.sub-menu li a:hover {
  color: var(--main-color1);
  padding-left: 25px;
}

.menu-phone {
  margin-top: 40px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 0.8s;
}

.fullscreen-menu.open .menu-phone {
  opacity: 1;
  transform: translateY(0);
}

.menu-phone a {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: transparent;
  color: #fff;
  padding: 16px 32px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  text-decoration: none;
  letter-spacing: 1px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-phone a:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.4);
}

.menu-phone a svg {
  opacity: 0.8;
}

/* Responsive */
@media (max-width: 1024px) {
  .menu-image-section {
    width: 45%;
  }

  .menu-content-section {
    width: 55%;
    padding: 80px 40px;
  }

  .image-overlay {
    padding: 40px;
  }

  .image-title {
    font-size: 26px;
  }
}

@media (max-width: 768px) {
  .header {
    padding: 12px 0;
    background: #182958;
  }

  .header-inner {
    padding: 0 16px;
    justify-content: space-between;
  }

  /* 모바일: 로고 왼쪽 */
  .logo {
    position: relative;
    left: auto;
    transform: none;
  }

  .logo img {
    height: 20px;
  }

  /* 모바일: 오른쪽 햄버거만 */
  .header-right {
    flex: 0;
    justify-content: flex-end;
    gap: 0;
  }

  /* PC용 전화박스 숨김 */
  .phone-box {
    display: none;
  }

  .hamburger-btn {
    width: 40px;
    height: 40px;
    gap: 5px;
  }

  .hamburger-btn span {
    width: 18px;
  }

  /* 모바일에서는 이미지 숨기고 메뉴만 표시 */
  .fullscreen-menu {
    flex-direction: column;
  }

  .menu-image-section {
    display: none;
  }

  .menu-content-section {
    width: 100%;
    padding: 100px 30px 40px;
    align-items: flex-start;
    transform: translateY(-100%);
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0.1s;
  }

  .fullscreen-menu.open .menu-content-section {
    transform: translateY(0);
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .menu-content-inner {
    max-width: 100%;
  }

  .menu-title {
    font-size: 20px;
    padding: 16px 0;
  }

  .sub-menu li a {
    font-size: 14px;
    padding: 10px 15px;
  }

  .menu-phone {
    margin-top: 30px;
  }

  .menu-phone a {
    padding: 14px 28px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .header-right {
    gap: 10px;
  }

  .phone-box {
    padding: 12px 16px;
  }

  .phone-box a {
    font-size: 13px;
    letter-spacing: 0.5px;
  }

  .hamburger-btn {
    width: 46px;
    height: 46px;
  }

  .menu-title {
    font-size: 18px;
  }
}
</style>